function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect, useMemo } from 'react';
import Cookies from 'js-cookie';
import { CookiePreferencesModal } from '@cb/cookie-manager';
import { Div, GlobalNavbar, CMSContent, CountryFooterDisclaimer } from '@cbhq/cdx-components';
import { getFlashMessage, FlashMessage } from '../components/FlashMessage.js';
import { GlobalFooter } from '../components/GlobalFooter.js';
import { useContentfulMicrocopy } from '../globals/microcopy.js';
import { getProjectConfigProps } from '../globals/projectSettings.js';
import { getSiteConfigProps } from '../globals/siteSettings.js';
import { getEntryProps } from '../utils/getEntryProps.js';
import { ResponsiveHeader } from './Header.js';
import { jsx, jsxs } from 'react/jsx-runtime';
function PageTemplateLayout({
  children,
  path,
  siteConfig,
  projectConfig,
  templateWidth = 1356,
  onSearch,
  countrySpecificFooterDisclaimer,
  applicationSettingsExtraProps
}) {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCookiePreferenceModalOpen = _useState2[0],
    setOpenCookiePreference = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    flashMessageComponent = _useState4[0],
    setFlashMessageComponent = _useState4[1];
  const _ref = projectConfig?.fields || {},
    customLogo = _ref.customLogo,
    flashMessages = _ref.flashMessages;
  useEffect(() => {
    const errorMessage = getFlashMessage(flashMessages);
    errorMessage && setFlashMessageComponent(/*#__PURE__*/jsx(FlashMessage, {
      message: errorMessage
    }));
  }, [flashMessages]);
  const _ref2 = applicationSettingsExtraProps || {},
    showCDXHeader = _ref2.showCDXHeader,
    customLogoHeight = _ref2.customLogoHeight;
  const _useMemo = useMemo(() => getProjectConfigProps(projectConfig, path), [projectConfig, path]),
    sharedContent = _useMemo.sharedContent,
    legalDisclaimer = _useMemo.legalDisclaimer;
  const _useMemo2 = useMemo(() => getSiteConfigProps(siteConfig), [siteConfig]),
    footer = _useMemo2.footer;
  const microcopies = useContentfulMicrocopy();
  const columnOneLinksWithCookieBanner = useMemo(() => {
    if (!footer) return;
    const firstLinkGroup = footer.columnOne[0];
    if (!firstLinkGroup) return [];
    return [_objectSpread(_objectSpread({}, firstLinkGroup), {}, {
      links: [...firstLinkGroup.links, {
        label: microcopies.global?.cookiePreferences || '',
        onClick: () => setOpenCookiePreference(true)
      }]
    }), ...footer.columnOne.slice(1)];
  }, [footer, microcopies]);
  const _useMemo3 = useMemo(() => getProjectConfigProps(projectConfig, path), [projectConfig, path]),
    productName = _useMemo3.productName,
    productUrl = _useMemo3.productUrl,
    subNavLinks = _useMemo3.subNavLinks,
    hasSearch = _useMemo3.hasSearch,
    searchTags = _useMemo3.searchTags,
    secondaryCtaLabel = _useMemo3.secondaryCtaLabel,
    secondaryCtaUrl = _useMemo3.secondaryCtaUrl,
    primaryCtaUrl = _useMemo3.primaryCtaUrl,
    primaryCtaLabel = _useMemo3.primaryCtaLabel,
    projectSettingsBanner = _useMemo3.banner,
    navbarStyleOverride = _useMemo3.navbarStyleOverride,
    primaryLogoImageUrl = _useMemo3.primaryLogoImageUrl,
    secondaryLogoHref = _useMemo3.secondaryLogoHref;
  const _useMemo4 = useMemo(() => getSiteConfigProps(siteConfig), [siteConfig]),
    navbar = _useMemo4.navbar,
    siteSettingsBanner = _useMemo4.banner;
  const ipCountryFromCookie = Cookies.get('ip_country')?.toUpperCase();
  return /*#__PURE__*/jsxs(Div, {
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    children: [showCDXHeader ? /*#__PURE__*/jsx(GlobalNavbar, _objectSpread(_objectSpread({
      banner: projectSettingsBanner || siteSettingsBanner,
      subnav: {
        productName,
        productUrl,
        subNavLinks,
        hasSearch,
        searchTags,
        onSearch
      }
    }, navbar), {}, {
      style: navbarStyleOverride || navbar.style,
      secondaryCtaLabel: secondaryCtaLabel || navbar.secondaryCtaLabel,
      secondaryCtaUrl: secondaryCtaUrl || navbar.secondaryCtaUrl,
      primaryCtaLabel: primaryCtaLabel || navbar.primaryCtaLabel,
      primaryCtaUrl: primaryCtaUrl || navbar.primaryCtaUrl,
      primaryLogoImageUrl: primaryLogoImageUrl,
      secondaryLogoHref: secondaryLogoHref,
      customLogoHeight: customLogoHeight
    })) : /*#__PURE__*/jsx(ResponsiveHeader, {
      path: path,
      onSearch: onSearch,
      siteConfig: siteConfig,
      projectConfig: projectConfig
    }), flashMessageComponent && /*#__PURE__*/jsx(Div, {
      spacingTop: 2.5,
      justifyContent: "center",
      children: /*#__PURE__*/jsx(Div, {
        width: "90%",
        spacing: 2.5,
        maxWidth: 700,
        background: "negative",
        borderRadius: "rounded",
        children: flashMessageComponent
      })
    }), /*#__PURE__*/jsx(Div, {
      alignItems: "center",
      flexDirection: "column",
      background: "background",
      width: "100%",
      overflowX: "clip",
      children: /*#__PURE__*/jsxs(Div, {
        flexDirection: "column",
        maxWidth: templateWidth,
        width: "100%",
        children: [children, /*#__PURE__*/jsx(CMSContent, {
          content: sharedContent ?? [],
          additionalProps: {
            productId: projectConfig?.fields?.productId
          }
        }), countrySpecificFooterDisclaimer && countrySpecificFooterDisclaimer.length > 0 && countrySpecificFooterDisclaimer.map(entry => {
          const _getEntryProps = getEntryProps(entry),
            countryCode = _getEntryProps.countryCode,
            disclaimer = _getEntryProps.disclaimer;
          const uppercaseCountryCodes = countryCode.map(code => code.toUpperCase());
          if (uppercaseCountryCodes.includes(ipCountryFromCookie)) {
            return /*#__PURE__*/jsx(CountryFooterDisclaimer, {
              disclaimer: disclaimer
            }, entry.sys.id);
          }
          return null;
        }), footer && /*#__PURE__*/jsx(GlobalFooter, {
          legalDisclaimer: legalDisclaimer,
          socialMediaLinks: footer.socialMediaLinks,
          columnOne: columnOneLinksWithCookieBanner,
          columnTwo: footer.columnTwo,
          columnThree: footer.columnThree,
          customLogo: customLogo,
          customLogoHeight: customLogoHeight,
          copyrightText: microcopies.global.copyright,
          renderCdxFooter: showCDXHeader
        })]
      })
    }), /*#__PURE__*/jsx(CookiePreferencesModal, {
      isOpen: isCookiePreferenceModalOpen
      // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
      ,

      onClose: () => setOpenCookiePreference(false)
    })]
  });
}
export { PageTemplateLayout };
//# sourceMappingURL=PageTemplateLayout.js.map
